export enum ExternalUserStatus {
  Locked = 'Locked',
  Invited = 'Invited',
  Active = 'Active',
  Unblocked = 'Unblocked'
}
